/** 메인 추천 테스트 리스트( 프로필 별 진행사항 리스트 ) */
export const TEST_MAIN_DATA = "TEST_MAIN_DATA";

/** 유저 선택 자녀 프로필 헤더 조회 */
export const USER_CHILD_PROFILE_SELECTED = "USER_CHILD_PROFILE_SELECTED";

/** 토픽 리스트 조회 */
export const GET_TOPIC_LIST = "GET_TOPIC_LIST";

/** 유저 프로필 아이콘 리스트 조회 */
export const GET_USER_ICON_LIST = "GET_USER_ICON_LIST";

/** 어린이 프로필 리스트 조회 */
export const GET_CHILD_PROFILE_LIST = "GET_CHILD_PROFILE_LIST";

/** 유저 자녀녀 전체 포인트 조회 */
export const USER_ALL_POINT_COUNT = "USER_ALL_POINT_COUNT";

/** 선택된 프로필의 총합 포인트 조회 */
export const USER_CHILD_POINT_COUNT = "USER_CHILD_POINT_COUNT";

/** 선택된 프로필의 총합 쿠폰 개수 조회 */
export const USER_CHILD_COUPON_COUNT = "USER_CHILD_COUPON_COUNT";

/** 유저 전체 쿠폰 개수 조회 */
export const USER_ALL_COUPON_COUNT = "USER_ALL_COUPON_COUNT";

/** 고객 센터 카테고리별 질문 리스트 조회 */
export const USER_QUESTIONS_CATEGORY = "USER_QUESTIONS_CATEGORY";

/** 총합 포인트 및 포인트 리스트 */
export const USER_CHILD_COUPON_HISTORY = "USER_CHILD_COUPON_HISTORY";

/** 유저 전체 쿠폰 리스트 */
export const USER_ALL_COUPON_HISTORY = "USER_ALL_COUPON_HISTORY";

/** 선택된 프로필의 총합 포인트 및 포인트 리스트 */
export const USER_POINT_HISTORY = "USER_POINT_HISTORY";

/** 유저 전체 포인트 및 포인트 리스트 */
export const USER_POINT_ALL_HISTORY = "USER_POINT_ALL_HISTORY";

/** 나의 1:1 문의내역 */
export const MY_QUESTIONS = "MY_QUESTIONS";

/** 관리자 */
/** 쓰기 리스트 조회 */
export const GET_STROKE_LIST = "GET_STROKE_LIST";

/** 진단 데이터 */
export const DIAGNOSTIC_MAIN_DATA = "DIAGNOSTIC_MAIN_DATA";

/** 진단 FAQ */
export const DIAGNOSTIC_MAIN_FAQ_DATA = "DIAGNOSTIC_MAIN_FAQ_DATA";

/** 진단 전문의 */
export const DIAGNOSTIC_MAIN_DOCTOR_DATA = "DIAGNOSTIC_MAIN_DOCTOR_DATA";

/** 커뮤니티 > 도서 */
export const DETAIL_BOOK_DATA = "DETAIL_BOOK_DATA";

/** 커뮤니티 > 도서 > 지금 주목받는 도서*/
export const HOT_BOOK_DATA = "HOT_BOOK_DATA";

/** 커뮤니티 > 도서 > 우리아이 추천도서*/
export const RECOMMEND_BOOK_DATA = "RECOMMEND_BOOK_DATA";

/** 커뮤니티 > 발달 > 집콕 플레이 메인 데이터 */
export const HOME_PLAY_DATA = "HOME_PLAY_DATA";

/** 커뮤니티 > 발달 > 우리아이는 잘 성장하고 있을까 데이터 */
export const GROW_DATA_MAIN = "GROW_MAIN_DATA";

/** 커뮤니티 > 발달 > 우리아이는 잘 성장하고 있을까 전체 데이터 */
export const GROW_DATA = "GROW_DATA";

/** 커뮤니티 > 육아상담소 > 탭별 육아 상담 게시글 조회*/
export const PARENTING_INFO_COUNSEL_BOARD_SELECT =
  "PARENTING_INFO_COUNSEL_BOARD_SELECT";

/** 커뮤니티 > 육아상담소 > 생활 정보통 최근 5개 데이터*/
export const PARENTING_INFO_LIFE_INFO = "PARENTING_INFO_LIFE_INFO";

/** 커뮤니티 > 육아상담소 > 최근 5개 게시글 데이터*/
export const PARENTING_INFO_COUNSEL_RECENT = "PARENTING_INFO_COUNSEL_RECENT";

/** 커뮤니티 > 육아상담소 > 육아상담소 디테일 페이지*/
export const PARENTING_INFO_COUNSEL_RECENT_DETAIL =
  "PARENTING_INFO_COUNSEL_RECENT_DETAIL";

/** 커뮤니티 > 육아상담소 > 전체 상담글*/
export const ALL_COUNSEL_POST_DATA = "ALL_COUNSEL_POST_DATA";

/** 커뮤니티 > 육아상담소 > 내가 쓴 글*/
export const MY_COUNSEL_POST_DATA = "MY_COUNSEL_POST_DATA";

/** 커뮤니티 > 육아상담소 > 육아상담소 작성*/
export const WRITE_PARENTING = "WRITE_PARENTING";

/** 커뮤니티 > 여행 > 이번 주 핫플 데이터 */
export const MAP_INFO_HOT_PLACE = "MAP_INFO_HOT_PLACE";

/** 커뮤니티 > 여행 > 근처 여행지 정보 데이터*/
export const MAP_INFO_TRAVEL_DETAIL = "MAP_INFO_TRAVEL_DETAIL";

/** 커뮤니티 > 여행 > 근처 여행지 정보 데이터*/
export const MAP_INFO_NEARBY = "MAP_INFO_NEARBY";

/** 커뮤니티 > 여행 > 전체 여행지 정보 데이터*/
export const MAP_INFO_ALLBY = "MAP_INFO_ALLBY";

/** 커뮤니티 > 콘테스트 > 콘테스트 베스트 작품 데이터*/
export const CONTEST_BEST = "CONTEST_BEST";

/** 커뮤니티 > 콘테스트 > 콘테스트 최근순 전체 작품*/
export const CONTEST_RECENT = "CONTEST_RECENT";

/** 커뮤니티 > 콘테스트 > 콘테스트 게시판 데이터*/
export const CONTEST_BOARD = "CONTEST_BOARD";

/** 커뮤니티 > 콘테스트 > 콘테스트 게시판 데이터*/
export const CONTEST_DETAIL_RECENT = "CONTEST_DETAIL_RECENT";

/** 마이페이지 > 통합 분석 > 학습 현황 */
export const ANALYSIS_MY_STUDY_STATUS = "ANALYSIS_MY_STUDY_STATUS";

/** 마이페이지 > 통합 분석 > 학습 현황 > 총 학습현황 파이차트 데이터 조회 */
export const ANALYSIS_MY_STUDY_STATUS_TOTAL = "ANALYSIS_MY_STUDY_STATUS_TOTAL";

/** 마이페이지 > 통합 분석 > 학습 현황 > 총 학습현황 카테고리 카운트 데이터 조회 */
export const ANALYSIS_MY_STUDY_STATUS_TOTAL_CATEGORY_COUNT =
  "ANALYSIS_MY_STUDY_STATUS_TOTAL_CATEGORY_COUNT";

/** 마이페이지 > 통합 분석 > 학습 현황 > 총 학습현황 블럭지수 데이터 조회 */
export const ANALYSIS_MY_STUDY_STATUS_TOTAL_BLOCK_INDEX =
  "ANALYSIS_MY_STUDY_STATUS_TOTAL_BLOCK_INDEX";

/** 마이페이지 > 통합 분석 > 발달 현황 > 총 점수 데이터 조회 */
export const DEVELOPMENT_SCORE = "DEVELOPMENT_SCORE";
